import { useState } from 'react';

type PythonProps = {
  paddValue?: number;
};

export const Python3 = ({ paddValue }: PythonProps) => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div style={{ paddingLeft: `${paddValue}px` }}>
      <code>{'from flask import Flask, jsonify'}</code>
      <br />
      <br />
      <code>{'app = Flask(__name__)'}</code>
      <br />
      <br />
      <code>{"@app.route('/api/data', methods=['GET'])"}</code>
      <br />
      <code>{'def get_data():'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {"data = {'message': 'Hello from Flask!'}"}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'return jsonify(data)'}
      </code>
      <br />
      <br />
      <code>{"if __name__ == '__main__':"}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'app.run(debug=True)'}
      </code>
      <br />
      <br />
    </div>
  );
};
